/**
 * Shared utility functions for the Copilot feature.
 */

/**
 * Generate a clean, descriptive thread title from a user message.
 */
export function generateThreadTitle(message: string): string {
  let title = message.trim();

  // Remove common question prefixes
  const prefixes = [
    /^(can you |could you |please |hey |hi |hello |what's |what is |show me |tell me |help me |i want to |i need to |i'd like to )/i
  ];
  for (const prefix of prefixes) {
    title = title.replace(prefix, '');
  }

  // Capitalize first letter
  title = title.charAt(0).toUpperCase() + title.slice(1);

  // Remove trailing punctuation for cleaner look
  title = title.replace(/[?!.]+$/, '');

  // Truncate at a word boundary, max 50 chars
  if (title.length > 50) {
    title = title.slice(0, 50);
    const lastSpace = title.lastIndexOf(' ');
    if (lastSpace > 30) {
      title = title.slice(0, lastSpace);
    }
    title = title + '...';
  }

  return title || 'New conversation';
}

/**
 * Friendly label for tool names shown during execution.
 */
const TOOL_LABELS: Record<string, string> = {
  get_fee_drag: 'Analyzing fees',
  get_exposures: 'Checking exposures',
  get_liquidity: 'Forecasting liquidity',
  search_documents: 'Searching documents',
  get_performance_attribution: 'Calculating performance',
  get_risk_metrics: 'Computing risk metrics',
  get_asset_allocation: 'Checking asset allocation',
  search_contacts: 'Searching contacts',
  get_deal_pipeline: 'Loading deal pipeline',
  get_contact_history: 'Loading contact history',
  get_recent_activities: 'Fetching activities',
  search_meeting_transcripts: 'Searching transcripts',
  get_portfolio_summary: 'Summarizing portfolio',
  extract_investment_interests: 'Extracting interests',
  detect_portfolio_gaps: 'Detecting gaps',
  create_action: 'Creating action',
  // Firm copilot tools
  get_firm_aum_summary: 'Loading firm AUM',
  get_cross_family_exposure: 'Checking cross-family exposure',
  compare_family_performance: 'Comparing family performance',
  find_deal_sharing_opportunities: 'Finding deal opportunities',
  get_firm_operational_status: 'Checking operational status',
  get_family_details: 'Loading family details',
};

export function getToolLabel(toolName: string): string {
  return TOOL_LABELS[toolName] || 'Processing';
}
